import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { TableDataResponse } from 'types/general';
import { ICustomCategory, ICustomCategoryValue } from 'types/income';

interface CreateCustomCategory {
  name: string;
}

interface EditCustomCategory {
  categoryId: string;
  data: Partial<CreateCustomCategory>;
}

interface DeleteCustomCategory {
  categoryId: string;
}

interface GetCustomCategoryValues {
  customCategoryId: string;
}

interface CreateCustomCategoryValue {
  categoryId: string;
  value: string;
}

interface EditCustomCategoryValue {
  categoryId: string;
  valueId: string;
  data: {
    name: string;
  };
}

interface DeleteCustomCategoryValue {
  categoryId: string;
  valueId: string;
}

export const loaders = {
  getCustomCategories: () => {
    return api<{ data: ICustomCategory[] }>({
      url: Endpoints.clientAdmin.employees.customCategories.root,
    });
  },
  createCustomCategory: ({ name }: CreateCustomCategory) => {
    return api<{ id: string }>({
      url: Endpoints.clientAdmin.employees.customCategories.create,
      data: { name },
      method: 'post',
    });
  },
  editCustomCategory: ({ categoryId, data }: EditCustomCategory) => {
    return api<{ id: string }>({
      url: Endpoints.clientAdmin.employees.customCategories.byId.root.replace(
        ':categoryId',
        categoryId,
      ),
      data,
      method: 'patch',
    });
  },
  deleteCustomCategory: ({ categoryId }: DeleteCustomCategory) => {
    return api({
      url: Endpoints.clientAdmin.employees.customCategories.byId.root.replace(
        ':categoryId',
        categoryId,
      ),
      method: 'delete',
    });
  },
  getCustomCategoryValues: ({ customCategoryId }: GetCustomCategoryValues) => {
    return api<TableDataResponse<ICustomCategoryValue>>({
      url: Endpoints.clientAdmin.employees.customCategories.byId.values.root.replace(
        ':categoryId',
        customCategoryId,
      ),
    });
  },
  createCustomCategoryValue: ({
    categoryId,
    value,
  }: CreateCustomCategoryValue) => {
    return api<{ id: string; name: string }>({
      url: `${Endpoints.clientAdmin.employees.customCategories.byId.values.root.replace(
        ':categoryId',
        categoryId,
      )}/create`,
      data: { name: value },
      method: 'post',
    });
  },
  editCustomCategoryValue: ({
    categoryId,
    valueId,
    data,
  }: EditCustomCategoryValue) => {
    return api<{ id: string }>({
      url: Endpoints.clientAdmin.employees.customCategories.byId.values.byId
        .replace(':categoryId', categoryId)
        .replace(':valueId', valueId),
      data,
      method: 'patch',
    });
  },
  deleteCustomCategoryValue: ({
    categoryId,
    valueId,
  }: DeleteCustomCategoryValue) => {
    return api({
      url: Endpoints.clientAdmin.employees.customCategories.byId.values.byId
        .replace(':categoryId', categoryId)
        .replace(':valueId', valueId),
      method: 'delete',
    });
  },
};
